(function () {
  function update(root, variant) {
    if (!root || !variant) return;

    const enquiryBtn = root.querySelector('.ck-enquiry-button');
    const atcBtn = root.querySelector('.add-to-cart-btn');
    const accordion = root.querySelector('.ck-enquiry__accordion');

    const formMessage = root.querySelector('[data-ck-form-message]');

    const mapEl = root.querySelector('[data-ck-enquiry-map]');

    if (!enquiryBtn || !atcBtn || !mapEl) return;

    let map;
    try { map = JSON.parse(mapEl.textContent); } catch (e) { return; }

    const showEnquiry = !!map[String(variant.id)];

    enquiryBtn.classList.toggle('hidden', !showEnquiry);
    atcBtn.classList.toggle('hidden', showEnquiry);

    if (accordion) {
      accordion.classList.toggle('show-enquiry', showEnquiry);
    }

    if (formMessage) {
      formMessage.classList.toggle('hidden', !showEnquiry);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[x-data^="Theme_Product"]').forEach((root) => {
      if (!window.Alpine) return;
      const data = Alpine.$data(root);
      if (data?.current_variant) update(root, data.current_variant);
    });
  });

  document.addEventListener('switch:product:variantchange', (e) => {
    update(e.target, e.detail && e.detail.variant);
  });

})();

(function () {
  function getPopup() {
    return document.querySelector('.ck-product-enquiry');
  }

  function openPopup() {
    const popup = getPopup();
    if (popup) popup.classList.add('show-enquiry');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    const popup = getPopup();
    if (popup) popup.classList.remove('show-enquiry');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {

    const openBtn = e.target.closest('.ck-enquiry-button');
    if (openBtn) {
      openPopup();
      return;
    }

    const closeBtn = e.target.closest('.ck-product-enquiry__close');
    if (closeBtn) {
      closePopup();
      return;
    }

    const popup = getPopup();
    if (!popup || !popup.classList.contains('show-enquiry')) return;

    const form = popup.querySelector('form');
    if (!form) return;

    if (form.contains(e.target)) return;

    closePopup();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePopup();
  });

})();

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const statusMsg =
      document.querySelector('.ck-product-enquiry [data-form-status]') ||
      document.querySelector('.ck-product-enquiry .form-message');

    if (!statusMsg) return;

    const messageClone = statusMsg.cloneNode(true);
    messageClone.setAttribute('data-ck-form-message', 'true');

    const enquiryBtn = document.querySelector('.ck-enquiry-button');
    if (!enquiryBtn) return;

    enquiryBtn.parentNode.insertBefore(messageClone, enquiryBtn);
  });
})();